export default __webpack_public_path__ + "static/media/dilimatrix-banner-whiteText.a2736648.png";